import { render, staticRenderFns } from "./PlusHeaderSettings.vue?vue&type=template&id=29c806d4"
import script from "./PlusHeaderSettings.vue?vue&type=script&lang=js"
export * from "./PlusHeaderSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports